<template>
 <div>
     <a-modal :title="title" v-model="visible" @ok="handleOk" class="rough-draft-model rough-draft-model-one">
         <div class="rough-draft-content">
      <span>
        确认后，当前页面的信息生成草稿单据，请在
        【单据-草稿单据】中查看。
      </span>
         </div>
     </a-modal>
     <a-modal :title="title1" v-model="visible1" @ok="handleOk1" class="rough-draft-model rough-draft-model-two">
         <div class="rough-draft-content1">
      <span>
        确认后，将生成单据，变更库存，相关财务科目的
          金额发生变化，可在 【单据-过账单据】中查看
      </span>
             <span class="rought-draft-span">注意：提交后不能修改，请谨慎操作</span>
         </div>
     </a-modal>
     <a-modal :title="title1" v-model="visible3" @ok="handleOk3" class="rough-draft-model rough-draft-model-two">
         <div class="rough-draft-content1">
      <span>
        确认后，将生成单据，变更库存，相关财务科目的
          金额发生变化，可在 【单据-过账单据】中查看
      </span>
             <span class="rought-draft-span">注意：提交后不能修改，请谨慎操作</span>
         </div>
     </a-modal>
     <a-modal :title="'温馨提示'" v-model="visible2" @ok="handleOk2" class="rough-draft-model rough-draft-model-two1" >
         <div class="rough-draft-content2">
           <!-- <img src="@/assets/image/tishi.png" alt="" class="tishi-model-two1"> -->
           <div class="rough-draft-content2-right">
             <!-- <span>您确认撤销为编辑？</span> -->
             <span>您确认要将此单撤回进行编辑吗？</span>
           </div>
         </div>
     </a-modal>
 </div>
</template>

<script>
export default {
  name: 'roughDraft',
  data () {
    return {
      title: '是否确认存为草稿',
      visible: false,
        title1: '是否确认提交过账',
        visible1: false,
        visible2:false,
        visible3:false
    }
  },
  methods: {
    show (index) {
        if(index == 1){
            this.visible = true
        }else if(index==2){
            this.visible1 = true
        }else if(index == 3){
            this.visible2 = true
        }else if(index == 4){
            this.visible3 = true
        }
    },
    cancel () {
      this.visible = false
        this.visible1 = false
        this.visible2 = false
        this.visible3 = false
    },
      //存为草稿
    handleOk () {
        this.visible = false
      this.$emit('btnOk',2)
    },
      //提交过账
    handleOk1 () {
        this.visible1 = false
      this.$emit('btnOk',1)

    },
      handleOk2(){
          this.visible2 = false
          this.$emit('btnOk',3)
      },
      handleOk3(){
          this.visible3 = false
          this.$emit('btnOk',4)
      }
  }
}
</script>
<style lang="scss">
.rough-draft-model-one {
  width: 520px !important;
  height: 250px !important;
}
.rough-draft-model-two {
  width: 520px !important;
  height: 320px !important;
}
.rough-draft-model {
  .ant-modal-content {
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      display: flex;
      justify-content: center;
      padding: 30px 0 20px 0;
    }
    .ant-btn {
      width: 148px;
      border-radius: 6px !important;
    }

    .rough-draft-content {
      width: 320px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
      .rough-draft-content1{
          width: 352px;
          display: flex;
          flex-direction: column;
          .rought-draft-span{
              color: #F0320C;
              font-size: 16px;
              padding-top: 20px;
          }
      }
      // .rough-draft-content2{
      //     padding-top: 50px;
      //     padding-bottom: 20px;
      //     width: 352px;
      //     display: flex;
      //     flex-direction: column;
      // }
  }
}
.rough-draft-model-two1{
    width: 460px !important;
    height: 260px !important;
    .rough-draft-content2{
      height: 30px;
      .ant-modal-body {
        display: flex;
        justify-content: center;
        padding: 0;
      }
      .tishi-model-two1 {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }
    }
}
</style>
